import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { FaqDataInfo, FaqGroupInfo, FaqInfo } from '@client/utils/shared-constants';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FaqService {
	constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {}

	add(faq: FaqInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;

		return from(this.db.list(`/faq/${faq.organization}/list`).push(faqObj)).pipe(map(_x => faq));
	}

	addGroup(faq: FaqGroupInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.list(`/faq/${faq.organization}/groups`).push(faqObj)).pipe(map(_x => faq));
	}

	delete(faq: FaqInfo): Observable<any> {
		return from(this.db.object(`/faq/${faq.organization}/list/${faq.id}`).remove()).pipe(map(_x => faq));
	}

	deleteGroup(faq: FaqGroupInfo): Observable<any> {
		return from(this.db.object(`/faq/${faq.organization}/groups/${faq.id}`).remove()).pipe(map(_x => faq));
	}

	getAll(): Observable<any> {
		return this.db.object('/faq').valueChanges();
	}

	getAllGroups(): Observable<any> {
		return this.db.object('/faq').valueChanges();
	}

	getAllVisible(organization): Observable<FaqDataInfo> {
		return this.db
			.object<FaqDataInfo>('/faq')
			.valueChanges()
			.pipe(
				map(a => {
					const f: any = a[organization];
					const s = a['_system'];

					const data = {
						groups: Object.keys(f.groups || {})
							.map(k => ({ ...f.groups[k], id: k }))
							.filter((x: any) => !!x.visible),
						list: Object.keys(f.list || {})
							.map(k => ({ ...f.list[k], id: k }))
							.filter((x: any) => !!x.visible)
					};
					const systemData = {
						groups: Object.keys(s.groups || {})
							.map(k => ({ ...s.groups[k], id: k }))
							.filter((x: any) => !!x.visible),
						list: Object.keys(s.list || {})
							.map(k => ({ ...s.list[k], id: k }))
							.filter((x: any) => !!x.visible)
					};
					data.groups = [...data.groups, ...systemData.groups];
					data.list = [...data.list, ...systemData.list];

					return data;
				})
			);
	}

	update(faq: FaqInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.object(`/faq/${faq.organization}/list/${faq.id}`).update(faqObj)).pipe(map(_x => faq));
	}

	updateGroup(faq: FaqGroupInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.object(`/faq/${faq.organization}/groups/${faq.id}`).update(faqObj)).pipe(map(_x => faq));
	}
}
